export const RedirectCallbackStrategyConfig = Object.freeze({
  keycloakCode: {
    code: 'code',
    state: 'state',
  },
  loginRequired: 'login-required',
  pkceMethod: 'S256',
  checkLoginIframe: false,
  flow: 'standard',
});
